import React, { useEffect, useRef } from 'react';
import '../Home/Home.jsx';

const Test2 = () => {
  const scrollContainerRef = useRef(null);

  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    const maxScrollLeft = scrollContainer.scrollWidth - scrollContainer.clientWidth;

    // Function to handle the infinite scroll effect
    const handleScroll = () => {
      if (scrollContainer.scrollLeft >= maxScrollLeft) {
        scrollContainer.scrollLeft = 0; // Reset to the start
      } else if (scrollContainer.scrollLeft === 0) {
        scrollContainer.scrollLeft = maxScrollLeft; // Jump to the end
      }
    };

    scrollContainer.addEventListener('scroll', handleScroll);

    return () => {
      scrollContainer.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className="scroll-container" ref={scrollContainerRef}>
      <div className="scroll-content">
        <section className="section" style={{ backgroundColor: '#ff8a80' }}>Section 1</section>
        <section className="section" style={{ backgroundColor: '#ff80ab' }}>Section 2</section>
        <section className="section" style={{ backgroundColor: '#b388ff' }}>Section 3</section>
        <section className="section" style={{ backgroundColor: '#8c9eff' }}>Section 4</section>
        <section className="section" style={{ backgroundColor: '#80d8ff' }}>Section 5</section>
        <section className="section" style={{ backgroundColor: '#a7ffeb' }}>Section 6</section>
        <section className="section" style={{ backgroundColor: '#ccff90' }}>Section 7</section>
        <section className="section" style={{ backgroundColor: '#ffff8d' }}>Section 8</section>
        <section className="section" style={{ backgroundColor: '#ffcc80' }}>Section 9</section>
        <section className="section" style={{ backgroundColor: '#ffab91' }}>Section 10</section>
      </div>
    </div>
  );
};

export default Test2;
